<section class="w-100 text-center delpmtbox">
  <svg-important-message-svg></svg-important-message-svg>
  <h5 class="delpmtheader">Unable to remove Bank Account</h5>
  <p class="delpmtpara">We couldn’t process the removal of <br/>
    Checking/Savings account <strong>{{ accountNumber }}.</strong></p>
  <p class="delpmtpara mb-0">If you need personal assistance,<br/>
    please contact our Customer Service Department at<br/>
    <ng-container *ngIf="policyId?.length === 6">
        <a href="tel:18009228276" class="mapfre link blue-link underline">1-800-922-8276</a>
    </ng-container>
    <ng-container *ngIf="policyId?.length > 6">
        <a href="tel:18009228276" class="mapfre link blue-link underline">1-855-627-3737</a>
    </ng-container>
  </p>
  <p class="delpmtpara fs-12">8am - 6pm (EST) Mon - Fri</p>
  <p class="mb-0">
      <a routerLink="/my-insurance" class="linkGoToAccount text-uppercase">GO TO MY ACCOUNT</a>
  </p>
</section>